import React from 'react';
import { superAdminView as SuperAdminView } from './superAdminView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';
import { cloneDeep } from 'lodash';

class SuperAdminComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCustomer: false,
      isLoading: false,
      showCustomerData: true,
      editMode: false,
      allCustomer: [],
      TypeOption:[{id: 'jira', displayLabel: 'JIRA', value: 'jira'},{id: 'azure', displayLabel: 'Azure Devops', value: 'azure'}],
      selected: {
        customerName: '',
        testDesign: true,
        testDataManagement: false,
        firstname: '',
        lastname: '',
        email: '',
        fromAD: false,
        projectManagement: '',
        password: '',
        fromDate: '',
        tillDate: ''
      }
    };
  }

  componentDidMount() {
    fetch.get({
      url: APP.Constants.SERVICE_URLS.USER_MANAGEMENT.FETCH,
      callbackHandler: (response) => {
        const { status, payload } = response;
        if (APP.Constants.SUCCESS === status) {
          const _state = cloneDeep(this.state);
          _state.allCustomer = payload;
          this.setState(_state);
        } else {
          this.setState({
            custOptions: []
          });
        }
      }
    });
  }

  onSaveClick = (event, item, name) => {
    const {
      customerName,
      firstname,
      lastname,
      email,
      password,
      testDataManagement,
      testDesign,
      fromDate,
      fromAD,
      projectManagement,
      id,
      tillDate
    } = this.state.selected;
    if (new Date(fromDate) > new Date(tillDate)) {
      alert('Start Date is greater than End Date ');
      return true;
    }
    const RequestBody = {
      customerName,
      fromDate,
      tillDate,
      firstname,
      lastname,
      email,
      testDataManagement,
      projectManagement : projectManagement || 'jira',
      testDesign,
      fromAD,
      id,
      role: 'ADMIN',
      password
    };
    const URL = APP.Constants.SERVICE_URLS.USER_MANAGEMENT.FETCH;
    this.setState({ isLoading: false }, () => {
      if (this.state.editMode) {
        fetch.put({
          url: URL,
          requestBody: RequestBody,
          callbackHandler: (res) => this.saveCustomerHandler(res, name)
        });
      } else {
        fetch.post({
          url: URL,
          requestBody: RequestBody,
          callbackHandler: (res) => this.saveCustomerHandler(res, name)
        });
      }
    });
  };

  saveCustomerHandler = (res, name) => {
    const { status } = res;
    if (APP.Constants.SUCCESS === status) {
      this.setState({
        showCustomer: false,
        showCustomerData: true,
        selected: {
          customerName: '',
          firstname: '',
          lastname: '',
          email: '',
          testDataManagement: false,
          testDesign: true,
          fromAD: false,
          password: '',
          projectManagement: '',
          fromDate: '',
          tillDate: ''
        }
      });
      fetch.get({
        url: APP.Constants.SERVICE_URLS.USER_MANAGEMENT.FETCH,
        callbackHandler: (response) => {
          const { status, payload } = response;
          if (APP.Constants.SUCCESS === status) {
            const _state = cloneDeep(this.state);
            _state.allCustomer = payload;
            this.setState(_state);
          }
        }
      });
    } else {
    }
  };

  onEditClicked = (eve, item) => {
    const _state = cloneDeep(this.state);
    _state.selected = item;
    _state.showCustomer = true;
    _state.showCustomerData = false;
    _state.editMode = true;
    this.setState(_state);
  };

  onDeleteClicked = (eve, item) => {
    const URL = APP.Constants.SERVICE_URLS.USER_MANAGEMENT.FETCH;
    fetch.delete({
      url: URL + '/' + item.id,
      callbackHandler: (res) => {
        const { status } = res;
        if (APP.Constants.SUCCESS === status) {
          const customerData = this.state.allCustomer.filter(
            (fil) => fil.id !== item.id
          );
          this.setState({ allCustomer: customerData });
        }
      }
    });
  };

  viewCustomer = () => {
    const _state = cloneDeep(this.state);
    _state.showCustomer = false;
    _state.showCustomerData = true;
    _state.editMode = false;
    this.setState(_state);
  };

  onCancelClick = (type) => {
    this.setState({
      showCustomer: false,
      showCustomerData: true,
      editMode: false,
      selected: {
        customerName: '',
        firstname: '',
        lastname: '',
        testDesign: true,
        testDataManagement: false,
        fromAD: false,
        email: '',
        projectManagement: '',
        password: '',
        fromDate: '',
        tillDate: ''
      }
    });
  };

  handleCustomer = () => {
    const _state = cloneDeep(this.state);
    _state.showCustomer = true;
    _state.showCustomerData = false;
    _state.editMode = false;
    this.setState(_state);
  };

  onChange = ({ id, value }) => {
    const _state = cloneDeep(this.state);
    _state.selected[id] = value;
    this.setState(_state);
  };

  render() {
    return (
      <SuperAdminView
        {...{
          ...this.state,
          onChange: this.onChange,
          onSaveClick: this.onSaveClick,
          handleCustomer: this.handleCustomer,
          onEditClicked: this.onEditClicked,
          onDeleteClicked: this.onDeleteClicked,
          viewCustomer: this.viewCustomer,
          onCancelClick: this.onCancelClick
        }}
      />
    );
  }
}

export default SuperAdminComponent;
